/**
 * Created by Rodrigo Quesada on 07/12/16.
 */

export let CoreError = Error;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/error/aliases.ts